import { useEffect, useRef } from "react";

import type React from "react";

type Row = {
  closeContextMenu?: () => void;
};

export const useIntersectionObserver = <T extends Row>(
  containerRef: React.RefObject<HTMLElement | null>,
  rowRefs: React.RefObject<T[] | null>
) => {
  const containerIntersectionObserver = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    containerIntersectionObserver.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio < 1) {
            rowRefs.current?.forEach((ref) => {
              ref?.closeContextMenu?.();
            });
          }
        });
      },
      {
        root: containerRef.current,
        threshold: 1.0,
      }
    );

    return () => {
      containerIntersectionObserver.current?.disconnect();
    };
  }, [containerRef, rowRefs]);

  return containerIntersectionObserver.current;
};
